import styled from 'styled-components';
import colors from '~/styles/colors';

export const Container = styled.footer`
  height: 5rem;
  padding: 3rem;
  background-color: ${colors.primary};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  svg {
    margin-right: 0.5rem;
  }
  a {
    text-decoration: none;
    color: #fff;
    margin-left: 0.2rem;
  }
  div {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
